import React, { useState } from 'react';

const ImageWithFallback = ({ fallbackSrc, src, alt, ...props }) => {
  const [imageSrc, setImageSrc] = useState(false);

  const handleError = () => {
    setImageSrc(fallbackSrc);
  };

  return (
    <img src={imageSrc || src} alt={alt} onError={handleError} {...props} />
  );
};

export default ImageWithFallback;
